import * as React from 'react';
import * as _ from 'lodash';
import { connect, Dispatch } from 'react-redux';
import {
    IApplicationState, AppActionCreators, XmTrackingActionCreators, IXmTrackingListResponse, XmListType,
    IXmTrackingCountResponse, IXmTrackingLookupDataResponse, IXmTrackingResponse, IXmTrackingCenterCountResponse, ActionCenterActionCreators,
    FileActionCreators
} from '@nkr/store/index';
import { IBaseResponse, IListItem, IXmTracking, IXmTrackingCenterCounts, IXmTrackingCounts } from '@nkr/models/index';
import { FileDocumentType, FileDocumentTypeDescription, XmResult } from '@nkr/enums/index';
import CenterTabs from './center-tabs';
import AdminTabs from './admin-tabs';
import ConfirmCancel from './confirm-cancel';
import MarkShippedOut from './mark-shipped-out';
import { tabMap } from './tab-map';
import { Actions } from './actions';
import { toast } from 'react-toastify';
import RecordResults from './record-results';
import { FilterCenterBy } from './filter-center-by';
import DetailsModal from './details-modal';
import UploadFinalXm from '../center-admin/action-center/pending-swaps/modals/upload-final-xm';
import Grid from './grid';
import { ControlLabel, Form, FormControl, FormGroup } from 'react-bootstrap';
import { downloadFile } from '@nkr/services/download-file';
import { FilterWrapper } from './styles';

interface IProps {
    centerId: number,
    tab: string
}

interface IStateProps { }

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getByCenter: (centerId: number, listType: XmListType) => Promise<IXmTrackingListResponse>,
    getCounts: () => Promise<IXmTrackingCountResponse>,
    getCountsByCenter: (centerId: number) => Promise<IXmTrackingCenterCountResponse>,
    getLookupData: () => Promise<IXmTrackingLookupDataResponse>,
    cancelRequest: (id: number, cancelReason: number) => Promise<IBaseResponse>,
    markReceived: (id: number, centerId: number) => Promise<IXmTrackingResponse>,
    markReceivedBack: (id: number, centerId: number) => Promise<IXmTrackingResponse>,
    markShippedOut: (id: number, trackingNumber: string, shippedDateTime: string, centerId: number) => Promise<IXmTrackingResponse>,
    markRemoteShipped: (id: number, trackingNumber: string, shippedDateTime: string, centerId: number) => Promise<IXmTrackingResponse>,
    markShippedBack: (id: number, trackingNumber: string, shippedDateTime: string, centerId: number) => Promise<IXmTrackingResponse>,
    requestUpdate: (id: number) => Promise<IBaseResponse>,
    recordResults: (id: number, rootCause: string, correctiveAction: string, result: XmResult, isDcComplete: boolean, initials: string, cellPronase: boolean, cellCount: string, cellViability: string, centerId: number, file: File) => Promise<IXmTrackingResponse>,
    updateDeadline: (id: number, deadline: string) => Promise<IBaseResponse>,
    getXmTrackingnDetails: (trackingId: number) => Promise<IXmTrackingResponse>,
    uploadFinalXm: (donorId: number, recipientId: number, acceptable: number, rootCause: string, correctiveAction: string, initials: string, finalXmFile: File) => Promise<IBaseResponse>,
    downloadFile: (docType: number, lookupId: number) => Promise<any>
}

type TProps = IProps & IStateProps & IDispatchProps;

interface IState {
    list: IXmTracking[],
    adminCounts: IXmTrackingCounts,
    centerCounts: IXmTrackingCenterCounts,
    resultList: IListItem[],
    statusList: IListItem[],
    xmTypeList: IListItem[],
    cancelReasons: IListItem[],
    listType: XmListType,
    xmStatus: number,
    xmType: number,
    filterCenterBy: FilterCenterBy,
    filterCenterId: number,
    cancel: {
        show: boolean,
        data: IXmTracking
    },
    shippedOut: {
        show: boolean,
        data: IXmTracking
    },
    remoteShipped: {
        show: boolean,
        data: IXmTracking
    },
    shippedBack: {
        show: boolean,
        data: IXmTracking
    },
    recordResults: {
        show: boolean,
        data: IXmTracking
    },
    details: {
        show: boolean,
        data: IXmTracking
    },
    uploadFinalXm: {
        show: boolean,
        data: IXmTracking,
        swap: string
    }
}

class XmTracking extends React.Component<TProps, IState> {
    readonly state: IState = {
        list: [],
        adminCounts: null,
        centerCounts: null,
        resultList: [],
        statusList: [],
        xmTypeList: [],
        cancelReasons: [],
        listType: 0,
        xmStatus: -1,
        xmType: -1,
        filterCenterBy: FilterCenterBy.RecipientCenter,
        filterCenterId: 0,
        cancel: {
            show: false,
            data: null
        },
        shippedOut: {
            show: false,
            data: null
        },
        remoteShipped: {
            show: false,
            data: null
        },
        shippedBack: {
            show: false,
            data: null
        },
        recordResults: {
            show: false,
            data: null
        },
        details: {
            show: false,
            data: null
        },
        uploadFinalXm: {
            show: false,
            data: null,
            swap: ''
        }
    };

    componentDidMount = () => {
        this.getData();
    };

    getData = () => {
        let { centerId } = this.props;
        let listType = tabMap.find(x => x.link.toUpperCase() == this.props.tab.toUpperCase());

        if (this.props.centerId > 0) {
            this.props.showLoading('Getting XM requests, one moment please...').then(() => {
                Promise.all([
                    this.props.getByCenter(centerId, listType.id),
                    this.props.getCountsByCenter(centerId),
                    this.props.getLookupData()
                ])
                    .then(([response, countsResponse, lookupDataResponse]) => {
                        if (response.data.success && lookupDataResponse.data.success) {
                            let list = response.data.results;
                            let centerCounts = countsResponse.data.results;
                            let { resultList, statusList, xmTypeList, cancelReasons } = lookupDataResponse.data.results;

                            this.setState({
                                list,
                                centerCounts,
                                resultList,
                                statusList,
                                xmTypeList,
                                cancelReasons,
                                listType: listType.id,
                            }, () => {
                                this.props.hideLoading();
                            });
                        } else {
                            this.props.hideLoading();
                        }
                    });
            });
        } else {
            this.props.showLoading('Getting XM requests, one moment please...').then(() => {
                Promise.all([
                    this.props.getByCenter(centerId, listType.id),
                    this.props.getCounts(),
                    this.props.getLookupData()
                ])
                    .then(([response, countsResponse, lookupDataResponse]) => {
                        if (response.data.success && countsResponse.data.success && lookupDataResponse.data.success) {
                            let list = response.data.results;
                            let adminCounts = countsResponse.data.results;
                            let { resultList, statusList, cancelReasons } = lookupDataResponse.data.results;

                            this.setState({
                                list,
                                adminCounts,
                                resultList,
                                statusList,
                                cancelReasons,
                                listType: listType.id,
                            }, () => {
                                this.props.hideLoading();
                            });
                        } else {
                            this.props.hideLoading();
                        }
                    });
            });
        }
    };

    updateData = () => {
        let { centerId } = this.props;
        let listType = tabMap.find(x => x.link.toUpperCase() == this.props.tab.toUpperCase());

        if (this.props.centerId > 0) {
            return this.props.showLoading('Getting XM requests, one moment please...').then(() => {
                return Promise.all([
                    this.props.getByCenter(centerId, listType.id),
                    this.props.getCountsByCenter(centerId)
                ])
                    .then(([response, countsResponse]) => {
                        if (response.data.success && countsResponse.data.success) {
                            let list = response.data.results;
                            let centerCounts = countsResponse.data.results;

                            this.setState({
                                list,
                                centerCounts,
                                listType: listType.id,
                            }, () => {
                                this.props.hideLoading();
                            });
                        } else {
                            this.props.hideLoading();
                        }
                    });
            });
        } else {
            return this.props.showLoading('Getting XM requests, one moment please...').then(() => {
                return Promise.all([
                    this.props.getByCenter(centerId, listType.id),
                    this.props.getCounts()
                ])
                    .then(([response, countsResponse]) => {
                        if (response.data.success && countsResponse.data.success) {
                            let list = response.data.results;
                            let adminCounts = countsResponse.data.results;

                            this.setState({
                                list,
                                adminCounts,
                                listType: listType.id,
                            }, () => {
                                this.props.hideLoading();
                            });
                        } else {
                            this.props.hideLoading();
                        }
                    });
            });
        }
    }

    handleXmTrackingDetails = (trackingId: number) => {
        this.props.showLoading('Getting XM Tracking Details, one moment please...').then(() => {
            this.props.getXmTrackingnDetails(trackingId).then(response => {
                if (response.data.success) {
                    this.setState({
                        details: {
                            show: true,
                            data: response.data.results
                        }
                    });
                }
                this.props.hideLoading();
            });
        });
    }

    handleCancelDetails = () => {
        this.setState({
            details: {
                show: false,
                data: null
            }
        });
    }

    getFilteredAndOrderedList = () => {
        let filteredList = this.state.list.filter(x => {
            let statusFilter = this.state.xmStatus != -1 ? x.xmStatusId == this.state.xmStatus : true;
            let typeFilter = this.state.xmType != -1 ? x.xmTypeId == this.state.xmType : true;
            let recipientCenterFilter = this.state.filterCenterBy == FilterCenterBy.RecipientCenter && this.state.filterCenterId > 0 ? x.recipientCenterId == this.state.filterCenterId : true;
            let donorCenterFilter = this.state.filterCenterBy == FilterCenterBy.DonorCenter && this.state.filterCenterId > 0 ? x.donorCenterId == this.state.filterCenterId : true;
            return statusFilter && typeFilter && recipientCenterFilter && donorCenterFilter;
        })

        return _.orderBy(filteredList, item => item.xmStatusDeadline, 'desc');
    }

    getCenters = () => {
        let recipientCenters = _.sortBy(
            _.uniqBy(this.state.list.map(x => {
                return {
                    id: x.recipientCenterId,
                    alias: x.recipientCenterAlias,
                    isRecipientCenter: true
                };
            }), item => item.id), item => item.alias);

        let donorCenters = _.sortBy(
            _.uniqBy(this.state.list.map(x => {
                return {
                    id: x.donorCenterId,
                    alias: x.donorCenterAlias,
                    isRecipientCenter: false
                };
            }), item => item.id), item => item.alias);

        let allCenters = [...recipientCenters, ...donorCenters];

        return allCenters;
    }

    handleTabChange = (listType: XmListType) => {
        let link = tabMap.find(x => x.id == listType).link;

        if (this.props.centerId > 0) {
            window.location.href = '/center/' + this.props.centerId + '/action-center/xm-tracking/' + link;
        } else {
            window.location.href = '/admin/xm-tracking/' + link;
        }
    }

    handleFilterCenterByChange = (filterCenterBy: FilterCenterBy) => {
        this.setState({
            filterCenterBy
        });
    }

    handleCenterChange = (filterCenterId: number) => {
        this.setState({
            filterCenterId
        });
    }

    handleStatusChange = (xmStatus: number) => {
        this.setState({
            xmStatus
        });
    }

    handleTypeChange = (xmType: number) => {
        this.setState({
            xmType
        });
    }

    handleAction = (eventKey: any, id: number) => {
        let data = this.state.list.find(x => x.id == id);

        if (eventKey == Actions.CancelRequest) {
            this.setState({
                cancel: {
                    show: true,
                    data
                }
            });
        }

        if (eventKey == Actions.MarkReceived) {
            this.handleMarkReceived(id, false);
        }

        if (eventKey == Actions.MarkReceivedBack) {
            this.handleMarkReceived(id, true);
        }

        if (eventKey == Actions.MarkShippedOut) {
            this.setState({
                shippedOut: {
                    show: true,
                    data
                }
            })
        }

        if (eventKey == Actions.MarkRemoteShipped) {
            this.setState({
                remoteShipped: {
                    show: true,
                    data
                }
            })
        }

        if (eventKey == Actions.DonorBloodDrawnShipped) {
            this.setState({
                shippedBack: {
                    show: true,
                    data
                }
            });
        }

        if (eventKey == Actions.RequestUpdate) {
            this.handleRequestUpdate(id);
        }

        if (eventKey == Actions.TrackPackage) {
            window.open('http://www.packagetrackr.com/track/' + data.shipOutTrackingNumber, '_blank');
        }

        if (eventKey == Actions.DonorHlaFile) {
            // window.open(`${__OUTSIDEURL__}/centers/download/donor-record.php?id=${data.donorId}&type=rawtyping`, '_blank');
            this.handleGetFile(FileDocumentType.DonorHistoTyping, data.donorId);
        }

        if (eventKey == Actions.DonorCtReport) {
            // window.open(`${__OUTSIDEURL__}/centers/download/donor-record.php?id=${data.donorId}&type=ctreport`, '_blank');
            this.handleGetFile(FileDocumentType.DonorCTReport, data.donorId);
        }

        if (eventKey == Actions.DonorMedicalChart) {
            // window.open(`${__OUTSIDEURL__}/centers/donor/med-chart-file.php?id=${data.donorId}`, '_blank');
            this.handleGetFile(FileDocumentType.DonorMedChart, data.donorId);
        }

        if (eventKey == Actions.RecordResults) {
            this.setState({
                recordResults: {
                    show: true,
                    data
                }
            });
        }

        if (eventKey == Actions.UploadFinalXm) {
            this.setState({
                uploadFinalXm: {
                    show: true,
                    data,
                    swap: `${data.chainNumber}/${data.clusterNumber}/${data.positionNumber}`
                }
            });
        }
    }

    handleSubmitCancelRequest = (cancelReason: number) => {
        let id = this.state.cancel.data.id;

        this.setState({
            cancel: {
                show: false,
                data: null
            }
        }, () => {
            this.props.showLoading('Cancelling the selected request, one moment please...').then(() => {
                this.props.cancelRequest(id, cancelReason).then(response => {
                    if (response.data.success) {
                        let list = _.cloneDeep(this.state.list).filter(x => x.id != id);

                        this.setState({
                            list
                        }, () => {
                            toast.success('XM Request Cancelled Successfully');
                        });
                    }

                    this.props.hideLoading();
                });
            });
        });
    }

    handleCancelConfirmCancelRequest = () => {
        this.setState({
            cancel: {
                show: false,
                data: null
            }
        });
    }

    handleMarkReceived = (id: number, wasReceivedBack: boolean) => {
        this.props.showLoading('Updating the selected request, one moment please...').then(async () => {
            let response = !wasReceivedBack ? await this.props.markReceived(id, this.props.centerId) : await this.props.markReceivedBack(id, this.props.centerId);

            if (response.data.success) {
                await this.updateData();
                toast.success('XM Request Updated Successfully');
            }

            this.props.hideLoading();
        });
    }

    handleSubmitShippedOut = (trackingNumber: string, shippedDateTime: string) => {
        let id = this.state.shippedOut.data.id;

        this.setState({
            shippedOut: {
                show: false,
                data: null
            }
        }, () => {
            this.props.showLoading('Updating the selected request, one moment please...').then(() => {
                this.props.markShippedOut(id, trackingNumber, shippedDateTime, this.props.centerId)
                    .then(async response => {
                        if (response.data.success) {
                            await this.updateData();
                            toast.success('XM Request Updated Successfully');
                        }
                    })
                    .finally(() => this.props.hideLoading());
            });
        });
    }

    handleCancelShippedOut = () => {
        this.setState({
            shippedOut: {
                show: false,
                data: null
            }
        });
    }

    handleSubmitRemoteShipped = (trackingNumber: string, shippedDateTime: string) => {
        let id = this.state.remoteShipped.data.id;

        this.setState({
            remoteShipped: {
                show: false,
                data: null
            }
        }, () => {
            this.props.showLoading('Updating the selected request, one moment please...').then(() => {
                this.props.markRemoteShipped(id, trackingNumber, shippedDateTime, this.props.centerId)
                    .then(async response => {
                        if (response.data.success) {
                            await this.updateData();
                            toast.success('XM Request Updated Successfully');
                        }
                    })
                    .finally(() => this.props.hideLoading());
            });
        });
    }

    handleCancelRemoteShipped = () => {
        this.setState({
            remoteShipped: {
                show: false,
                data: null
            }
        });
    }

    handleSubmitShippedBack = (trackingNumber: string, shippedDateTime: string) => {
        let id = this.state.shippedBack.data.id;

        this.setState({
            shippedBack: {
                show: false,
                data: null
            }
        }, () => {
            this.props.showLoading('Updating the selected request, one moment please...').then(() => {
                this.props.markShippedBack(id, trackingNumber, shippedDateTime, this.props.centerId)
                    .then(async response => {
                        if (response.data.success) {
                            await this.updateData();
                            toast.success('XM Request Updated Successfully');
                        }
                    })
                    .finally(() => this.props.hideLoading());;
            });
        });
    }

    handleCancelShippedBack = () => {
        this.setState({
            shippedBack: {
                show: false,
                data: null
            }
        });
    }

    handleRequestUpdate = (id: number) => {
        this.props.showLoading('Submitting request, one moment please...').then(async () => {
            let response = await this.props.requestUpdate(id);

            if (response.data.success) {
                toast.success('XM Request Updated Successfully');
            }

            this.props.hideLoading();
        });
    }

    handleRecordResults = (result: number, cellCount: number, cellViability: number, pronaseTreated: number, isDcComplete: number, rootCause: string, correctiveAction: string, initials: string, file: File) => {
        let id = this.state.recordResults.data.id;

        this.setState({
            recordResults: {
                show: false,
                data: null
            }
        }, () => {
            this.props.showLoading('Updating the selected request, one moment please...').then(() => {
                this.props.recordResults(id, rootCause, correctiveAction, result, isDcComplete == 1, initials, pronaseTreated == 1, cellCount.toString(), cellViability.toString(), this.props.centerId, file)
                    .then(async response => {
                        if (response.data.success) {
                            await this.updateData();
                            toast.success('XM Request Updated Successfully');
                        }
                    })
                    .catch(error => {
                        toast.error('Unable to record results');
                    })
                    .finally(() => this.props.hideLoading());
            });
        });
    }

    handleCancelRecordResults = () => {
        this.setState({
            recordResults: {
                show: false,
                data: null
            }
        });
    }

    handleUpdateDeadline = (id: number, deadline: string) => {
        this.props.showLoading('Updating deadline, one moment please...').then(async () => {
            let response = await this.props.updateDeadline(id, deadline);

            if (response.data.success) {
                let list = _.cloneDeep(this.state.list).map(x => {
                    if (x.id == id) {
                        x.xmStatusDeadline = deadline;
                    }

                    return x;
                });

                this.setState({
                    list
                }, () => {
                    toast.success('XM Deadline Updated Successfully');
                });
            }

            this.props.hideLoading();
        });
    }

    handleShowUploadFinalXm = (donorId: number, recipientId: number) => {
        let data = this.state.list.find(x => x.donorId == donorId && x.recipientId == recipientId);

        this.setState({
            uploadFinalXm: {
                show: true,
                data,
                swap: `${data.chainNumber}/${data.clusterNumber}/${data.positionNumber}`
            }
        });
    }

    handleUploadFinalXm = (acceptable: number, rootCause: string, correctiveAction: string, initials: string, finalXmFile: File) => {
        let { id, donorId, recipientId } = this.state.uploadFinalXm.data;

        this.setState({
            uploadFinalXm: {
                show: false,
                data: null,
                swap: ''
            }
        }, () => {
            this.props.showLoading('Saving Final XM Results, one moment please...').then(() => {
                this.props.uploadFinalXm(donorId, recipientId, acceptable, rootCause, correctiveAction, initials, finalXmFile).then(
                    response => {
                        if (response.data.success) {
                            let list = _.cloneDeep(this.state.list).map(x => {
                                if (x.id == id) {
                                    x.uploadFinalXmResults = false;
                                }

                                return x;
                            });

                            this.setState({
                                list
                            }, () => {
                                toast.success('Final XM Uploaded Successfully');
                                this.getData();
                            });
                        } else {
                            toast.error('Could not upload the final XM');
                        }
                    }
                )

                this.props.hideLoading();
            });
        });
    }

    handleCancelUploadFinalXm = () => {
        this.setState({
            uploadFinalXm: {
                show: false,
                data: null,
                swap: ''
            }
        });
    }

    handleGetFile = (docType: FileDocumentType, donorId: number) => {
        this.props.downloadFile(docType, donorId).then((response: any) => {
            downloadFile(response.data, `${FileDocumentTypeDescription[docType]}.pdf`, response.headers.contentType)
        }).catch((error: IBaseResponse) => {
            toast.error("Unable to download file at this time.  Please contact support.");
        })
    }


    render = () => {
        const list = this.getFilteredAndOrderedList();
        const centers = this.getCenters();

        return (
            <>
                <div style={{ padding: '0px 10px 10px' }}>
                    <div>
                        {this.props.centerId > 0 ?
                            <>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
                                    <div><h4>XM Tracking</h4></div>

                                    <CenterTabs
                                        listType={this.state.listType}
                                        counts={this.state.centerCounts}
                                        currentStatus={this.state.xmStatus}
                                        currentType={this.state.xmType}
                                        statusList={this.state.statusList}
                                        xmTypeList={this.state.xmTypeList}
                                        onTabChange={this.handleTabChange} />
                                </div>

                                {[XmListType.History, XmListType.All].indexOf(this.state.listType) >= 0 && (
                                    <FilterWrapper bsSize='sm'>
                                        <Form inline>
                                            <FormGroup bsSize='sm' style={{ marginRight: 20 }}>
                                                <ControlLabel>Filter by Status:</ControlLabel>{' '}
                                                <FormControl
                                                    componentClass='select'
                                                    value={this.state.xmStatus}
                                                    onChange={(e: React.FormEvent<FormControl & HTMLSelectElement>) => this.handleStatusChange(parseInt(e.currentTarget.value))}
                                                >
                                                    <option value={-1}>- ALL -</option>
                                                    {this.state.statusList.map(item =>
                                                        <option value={item.id}>{item.description}</option>
                                                    )}
                                                </FormControl>
                                            </FormGroup>

                                            <FormGroup bsSize='sm'>
                                                <ControlLabel>Filter by Type:</ControlLabel>{' '}
                                                <FormControl
                                                    componentClass='select'
                                                    value={this.state.xmType}
                                                    onChange={(e: React.FormEvent<FormControl & HTMLSelectElement>) => this.handleTypeChange(parseInt(e.currentTarget.value))}
                                                >
                                                    <option value={-1}>- ALL -</option>
                                                    {this.state.xmTypeList.map(item =>
                                                        <option value={item.id}>{item.description}</option>
                                                    )}
                                                </FormControl>
                                            </FormGroup>
                                        </Form>
                                    </FilterWrapper>
                                )}
                            </>
                            :
                            <AdminTabs
                                listType={this.state.listType}
                                counts={this.state.adminCounts}
                                filterCenterBy={this.state.filterCenterBy}
                                filterCenterId={this.state.filterCenterId}
                                centerList={centers}
                                onTabChange={this.handleTabChange}
                                onFilterCenterByChange={this.handleFilterCenterByChange}
                                onCenterChange={this.handleCenterChange}
                            />
                        }
                    </div>

                    <Grid
                        data={list}
                        centerId={this.props.centerId}
                        listType={this.state.listType}
                        onAction={this.handleAction}
                        onXmTrackingDetails={this.handleXmTrackingDetails}
                        onUpdateDeadline={this.handleUpdateDeadline}
                        onShowUploadFinalXm={this.handleShowUploadFinalXm}
                    />
                </div>

                <ConfirmCancel
                    show={this.state.cancel.show}
                    data={this.state.cancel.data}
                    cancelReasons={this.state.cancelReasons}
                    onSubmit={this.handleSubmitCancelRequest}
                    onCancel={this.handleCancelConfirmCancelRequest}
                />

                <MarkShippedOut
                    key={'mark-shipped-out-' + (this.state.shippedOut.data != null ? this.state.shippedOut.data.id : -1)}
                    show={this.state.shippedOut.show}
                    data={this.state.shippedOut.data}
                    title={'Mark Shipped'}
                    onSubmit={this.handleSubmitShippedOut}
                    onCancel={this.handleCancelShippedOut}
                />

                <MarkShippedOut
                    key={'mark-remote-shipped-' + (this.state.remoteShipped.data != null ? this.state.remoteShipped.data.id : -1)}
                    show={this.state.remoteShipped.show}
                    data={this.state.remoteShipped.data}
                    title={'Mark Remote Shipped'}
                    onSubmit={this.handleSubmitRemoteShipped}
                    onCancel={this.handleCancelRemoteShipped}
                />

                <MarkShippedOut
                    key={'mark-shipped-back-' + (this.state.shippedBack.data != null ? this.state.shippedBack.data.id : -1)}
                    show={this.state.shippedBack.show}
                    data={this.state.shippedBack.data}
                    title={'Mark Shipped Back'}
                    onSubmit={this.handleSubmitShippedBack}
                    onCancel={this.handleCancelShippedBack}
                />

                <RecordResults
                    show={this.state.recordResults.show}
                    data={this.state.recordResults.data}
                    resultList={this.state.resultList}
                    onSubmit={this.handleRecordResults}
                    onCancel={this.handleCancelRecordResults}
                />

                <UploadFinalXm
                    show={this.state.uploadFinalXm.show}
                    swap={this.state.uploadFinalXm.swap}
                    onSend={this.handleUploadFinalXm}
                    onCancel={this.handleCancelUploadFinalXm}
                />

                <DetailsModal
                    show={this.state.details.show}
                    data={this.state.details.data}
                    onCancel={this.handleCancelDetails}
                />
            </>
        );
    }
}

const mapStateToProps = (appState: IApplicationState): IStateProps => {
    return {
        app: appState.app
    };
};

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getByCenter: (centerId, listType) => {
            return dispatch(XmTrackingActionCreators.getByCenter(centerId, listType));
        },
        getCounts: () => {
            return dispatch(XmTrackingActionCreators.getCounts());
        },
        getCountsByCenter: (centerId) => {
            return dispatch(XmTrackingActionCreators.getCountsByCenter(centerId));
        },
        getLookupData: () => {
            return dispatch(XmTrackingActionCreators.getLookupData());
        },
        cancelRequest: (id, cancelReason) => {
            return dispatch(XmTrackingActionCreators.cancelRequest(id, cancelReason));
        },
        markReceived: (id, centerId) => {
            return dispatch(XmTrackingActionCreators.markReceived(id, centerId));
        },
        markReceivedBack: (id, centerId) => {
            return dispatch(XmTrackingActionCreators.markReceivedBack(id, centerId));
        },
        markShippedOut: (id, trackingNumber, shippedDateTime, centerId) => {
            return dispatch(XmTrackingActionCreators.markShippedOut(id, trackingNumber, shippedDateTime, centerId));
        },
        markRemoteShipped: (id, trackingNumber, shippedDateTime, centerId) => {
            return dispatch(XmTrackingActionCreators.markRemoteShipped(id, trackingNumber, shippedDateTime, centerId));
        },
        markShippedBack: (id, trackingNumber, shippedDateTime, centerId) => {
            return dispatch(XmTrackingActionCreators.markShippedBack(id, trackingNumber, shippedDateTime, centerId));
        },
        requestUpdate: (id) => {
            return dispatch(XmTrackingActionCreators.requestUpdate(id));
        },
        recordResults: (id, rootCause, correctiveAction, result, isDcComplete, initials, cellPronase, cellCount, cellViability, centerId, file) => {
            return dispatch(XmTrackingActionCreators.recordResults(id, rootCause, correctiveAction, result, isDcComplete, initials, cellPronase, cellCount, cellViability, centerId, file));
        },
        updateDeadline: (id, deadline) => {
            return dispatch(XmTrackingActionCreators.updateDeadline(id, deadline));
        },
        getXmTrackingnDetails: (trackingId) => {
            return dispatch(XmTrackingActionCreators.getById(trackingId));
        },
        uploadFinalXm: (donorId, recipientId, acceptable, rootCause, correctiveAction, initials, finalXmFile) => {
            return dispatch(ActionCenterActionCreators.uploadFinalXm(donorId, recipientId, acceptable, rootCause, correctiveAction, initials, finalXmFile));
        },
        downloadFile: (docType, id) => {
            return dispatch(FileActionCreators.downloadFile(docType, id))
        }
    };
};

export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(XmTracking);